/**
 * Streets missing from data.gov.il for a settlement but commonly spoken in search.
 * Merged on top of {@link israelStreetsBySettlement.json} (survives street sync).
 * Keys are CBS סמל_ישוב.
 */
export const ISRAEL_STREET_CATALOG_EXTRAS: Readonly<Record<string, readonly string[]>> = {
  /** תל אביב - יפו — שינקין is absent from the CBS dump for 5000. */
  '5000': ['שינקין'],
};
